import React from 'react';
import { Box, Button, Text, VStack, Badge, Image } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const MensalistaWelcome = ({ name, fotoUrl, onStartService }) => {
  const bgUrl = fotoUrl || "/background.jpg";
  console.log('MensalistaWelcome - Componente renderizado com nome:', name, 'fotoUrl:', bgUrl);
  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      height="100vh"
      width="100vw"
      minHeight="100dvh"
      bg="black"
      backgroundImage={`linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('${bgUrl}')`}
      backgroundSize="cover"
      backgroundPosition="center center"
      backgroundRepeat="no-repeat"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding={8}
      style={{
        aspectRatio: '9/16', // favorece vertical
        maxWidth: '100vw',
        maxHeight: '100dvh',
      }}
    >
      {/* Fallback visual se a imagem não carregar */}
      {!fotoUrl && (
        <Box position="absolute" top={0} left={0} width="100%" height="100%" bg="gray.900" opacity={0.7} zIndex={0}></Box>
      )}
      <VStack spacing={0} align="center" width="100%" height="100%" justify="flex-start" flex={1}>
        {/* Logo da Barbearia - maior e mais acima */}
        <MotionBox
          initial={{ y: -80 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          width={{ base: '180px', md: '260px' }}
          height={{ base: '180px', md: '260px' }}
          mt={{ base: 8, md: 12 }}
          mb={4}
        >
          <Image
            src={require('../assets/Logo-Barber.png')}
            alt="Barbearia Freire"
            width="100%"
            height="100%"
            objectFit="contain"
            style={{ filter: 'drop-shadow(0 0 32px #0008)' }}
          />
        </MotionBox>

        {/* Centralização vertical do badge + texto */}
        <Box flex={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" minHeight="320px">
          {/* Badge de Mensalista */}
          <MotionBox
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3, delay: 0.4 }}
          >
            <Badge
              bg="yellow.400"
              color="black"
              fontSize={{ base: 'lg', md: '2xl' }}
              fontWeight="bold"
              px={6}
              py={3}
              borderRadius="full"
              boxShadow="md"
              letterSpacing={2}
            >
              MENSALISTA
            </Badge>
          </MotionBox>

          {/* Mensagem de Boas-vindas */}
          <VStack spacing={2} mt={6} mb={2}>
            <MotionBox
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <Text fontSize={{ base: '2xl', md: '4xl' }} fontWeight="bold" textAlign="center" letterSpacing={1} color="white">
                SEJA BEM VINDO!
              </Text>
            </MotionBox>
            <MotionBox
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.8 }}
            >
              <Text fontSize={{ base: '3xl', md: '5xl' }} fontWeight="extrabold" color="yellow.400" textAlign="center" letterSpacing={2}>
                {name.toUpperCase()}
              </Text>
            </MotionBox>
          </VStack>
        </Box>

        {/* Botão de Iniciar Atendimento - destacado e mais abaixo */}
        <MotionBox
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, delay: 1 }}
          width="100%"
          maxWidth="440px"
          mb={{ base: 8, md: 14 }}
        >
          <Button
            size="lg"
            height={{ base: "70px", md: "90px" }}
            width="100%"
            fontSize={{ base: "2xl", md: "2xl" }}
            bg="white"
            color="black"
            fontWeight="bold"
            borderRadius="2xl"
            boxShadow="0 8px 32px #0007"
            _hover={{ bg: 'yellow.300', color: 'black', transform: 'scale(1.04)' }}
            _active={{ bg: 'yellow.400' }}
            letterSpacing={1}
            onClick={onStartService}
          >
            <Box as="span" fontSize="2xl" mr={3}>✂️</Box>
            Iniciar Atendimento
          </Button>
        </MotionBox>
      </VStack>
    </MotionBox>
  );
};

export default MensalistaWelcome;
